module.exports = "pegasus/assets/background-patterns/theme2_theme.jpg";